import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=dedc961a"
import script from "./metadata.vue?vue&type=script&lang=js"
export * from "./metadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports